import Vue from "vue";
import Router from "vue-router";

import BaseView from "../views/BaseView";
import OrderView from "../views/OrderView";
import CollectView from "../views/CollectView";
import AddressView from "../views/AddressView";
import PayView from "../views/PayView";
import InvoiceView from "../views/InvoiceView";
import PaySuccessView from "../views/PaySuccessView";

import CouponView from "../views/CouponView";
import InfoView from "../views/InfoView";
import MyInvoiceView from "../views/MyInvoiceView";
import RechargeView from "../views/RechargeView";

import ChargeRecord from "../views/ChargeRecord";
import PayRecord from "../views/PayRecord";
import WithdrawRecord from "../views/WithdrawRecord";
import ResetView from "../views/ResetView";
import MessageView from "../views/MessageView";
import HomeView from "../views/HomeView";
import EnterpriseView from "../views/EnterpriseView";
import IdentityView from "../views/IdentityView";
import RebateIntro from "../views/RebateIntro";
import RecommendStat from "../views/RecommendStat";
import RebateStat from "../views/RebateStat";
import DiscussView from "../views/DiscussView";
import WithinOrders from "../views/withinOrders";

Vue.use(Router);

const config = {
  // mode: 'history',
  routes: [
    {
      path: "/",
      redirect: "/pages/",
    },
    {
      path: "/pages",
      component: BaseView,
      children: [
        {
          path: "",
          redirect: "/pages/home",
        },
        {
          path: "home",
          name: "HomeView",
          component: HomeView,
        },
        {
          path: "collect",
          name: "CollectView",
          component: CollectView,
        },
        {
          path: "address",
          name: "AddressView",
          component: AddressView,
        },
        // {
        //     path: 'home',
        //     name: 'HomeView',
        //     component: HomeView,
        // },
        {
          path: "order",
          name: "OrderView",
          component: OrderView,
        },
        {
          path: "coupon",
          name: "CouponView",
          component: CouponView,
        },
        {
          path: "info",
          name: "InfoView",
          component: InfoView,
        },
        {
          path: "myInvoice",
          name: "MyInvoiceView",
          component: MyInvoiceView,
        },
        {
          path: "chargeRecord",
          name: "ChargeRecord",
          component: ChargeRecord,
        },
        {
          path: "payRecord",
          name: "PayRecord",
          component: PayRecord,
        },
        {
          path: "withdrawRecord",
          name: "WithdrawRecord",
          component: WithdrawRecord,
        },
        {
          path: "reset",
          name: "ResetView",
          component: ResetView,
        },
        {
          path: "recharge",
          name: "RechargeView",
          component: RechargeView,
        },
        {
          path: "message",
          name: "MessageView",
          component: MessageView,
        },
        {
          path: "enterprise",
          name: "EnterpriseView",
          component: EnterpriseView,
        },
        {
          path: "identity",
          name: "IdentityView",
          component: IdentityView,
        },
        {
          path: "rebateIntro",
          name: "RebateIntro",
          component: RebateIntro,
        },
        {
          path: "recommend",
          name: "RecommendStat",
          component: RecommendStat,
        },
        {
          path: "rebate",
          name: "RebateStat",
          component: RebateStat,
        },
        {
          path: "discuss",
          name: "Discuss",
          component: DiscussView,
        },
      ],
    },
    {
      path: "/pay",
      name: "PayView",
      component: PayView,
    },
    {
      path: "/invoice",
      name: "InvoiceView",
      component: InvoiceView,
    },
    {
      path: "/success",
      name: "PaySuccessView",
      component: PaySuccessView,
    },
    {
      path: "/withinOrders",
      name: "WithinOrders",
      component: WithinOrders,
    },
    {
      path: "*",
      redirect: "/pages/",
    },
  ],
};

const router = new Router(config);
/**
 * 页面计数
 * @type {Number}
 */
window.$pageCount = -1;
router.beforeEach((to, from, next) => {
  window.$pageCount++;
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js